import { Button, Layout } from '../../widgets'

// prop requirements:

// state.items: object for ids -> items
// state.activeIds: array of active ids
// state.inactiveIds: array of inactive ids
// state.saving: bool whether saving is occurring

// setState: function to set state
// getItemId: function to get an item's id
// itemRow: function to render an item row
// save: function to save changes
// newItem: function to perform a new item action
// showDeleteButton: function to determine whether the delete button should be shown
// delete: function to perform a delete of an item

const moveUp = (props, id) => {
  const index = props.state.activeIds.indexOf(id)
  const activeIds = [...props.state.activeIds]

  const swappedId = activeIds[index-1]
  activeIds[index-1] = id
  activeIds[index] = swappedId

  props.setState({ activeIds })
}

const moveDown = (props, id) => {
  const index = props.state.activeIds.indexOf(id)
  const activeIds = [...props.state.activeIds]

  const swappedId = activeIds[index+1]
  activeIds[index+1] = id
  activeIds[index] = swappedId

  props.setState({ activeIds })
}

const activate = (props, id) => {
  const index = props.state.inactiveIds.indexOf(id)
  const activeIds = [...props.state.activeIds]
  const inactiveIds = [...props.state.inactiveIds]

  activeIds.push(id)
  inactiveIds.splice(index, 1)

  props.setState({ activeIds, inactiveIds })
}

const deactivate = (props, id) => {
  const index = props.state.activeIds.indexOf(id)
  const activeIds = [...props.state.activeIds]
  const inactiveIds = [...props.state.inactiveIds]

  activeIds.splice(index, 1)
  inactiveIds.push(id)

  props.setState({ activeIds, inactiveIds })
}

const activeRow = (props, item, index) => {
  return props.itemRow(item, index,
    <div className='orderable-items-move'>
      {index > 0 &&
        <button onClick={() => moveUp(props, props.getItemId(item))}>
          ⬆
        </button>
      }
      {index < props.state.activeIds.length - 1 &&
        <button onClick={() => moveDown(props, props.getItemId(item))}>
          ⬇
        </button>
      }
      <button onClick={() => deactivate(props, props.getItemId(item))}>
        Deactivate
      </button>
    </div>
  )
}

const inactiveRow = (props, item, index) => {
  return props.itemRow(item, index,
    <div className='orderable-items-move'>
      <button onClick={() => activate(props, props.getItemId(item))}>
        Activate
      </button>
      {props.showDeleteButton(item) &&
        <button onClick={() => props.delete(item)}>
          Delete
        </button>
      }
    </div>
  )
}

export default (props) => {
  return (
    <div>
      <div className='flex-row'>
        <Button
          onClick={() => props.save()}
          loading={props.state.saving}
        >
          Save
        </Button>
        <Button onClick={() => props.newItem()}>
          New
        </Button>
      </div>
      <Layout.Header>Active</Layout.Header>
      {props.state.activeIds.length ? props.state.activeIds.map((id, index) => activeRow(props, props.state.items[id], index)) : 'No active content'}
      <Layout.Header>Inactive</Layout.Header>
      {props.state.inactiveIds.length ? props.state.inactiveIds.map((id, index) => inactiveRow(props, props.state.items[id], index)) : 'No inactive content'}
    </div>
  )
}
